import React from 'react'
import ResetForm from './ResetForm'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { hashHistory } from 'react-router'
import * as request from 'superagent'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class GeneratePassword extends React.Component {
  reset (npassword, cpassword) {
    let token = this.props.params.token

    if (npassword === '' || cpassword === '') {
      this.refs.container.error('Los campos no pueden estar vacios', '', {
        closeButton: true
      })
    } else if (npassword !== cpassword) {
      this.refs.container.error('Las contraseñas no coinciden', '', {
        closeButton: true
      })
    } else {
      request
        .post('api/v1/user/reset')
        .send({ token: token, password: npassword })
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err || !res.ok) {
            console.log('res', res)
          } else {
            this.refs.container.success('La contraseña se guardó satisfactoriamente', 'Contraseña actualizada', {
              closeButton: true
            })
            setTimeout(() => { hashHistory.push('/') }, 2000)
          }
        })
    }
  }

  render () {
    document.title = 'Generar Contraseña - CORE 3.0'
    return (
      <div className='form-page-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <h2>Generar contraseña</h2>
        <ResetForm reset={this.reset.bind(this)}/>
      </div>
    )
  }
}

/* Validate Props */
GeneratePassword.propTypes = {
  params: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Account/Reset/ResetComponent.js